import { Link } from "react-router-dom";
import { MapPin, Phone, Facebook, Bus, TramFront } from "lucide-react";
import { BRAND } from "@/lib/data";
import { useContent } from "@/lib/content";
import { getActiveHours } from "@/lib/hours";

const WEEKDAYS = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];

export const Footer = () => {
  const c = useContent();
  const b = c.brand;
  const today = WEEKDAYS[new Date().getDay()];
  const season = getActiveHours(c);

  return (
    <footer data-testid="main-footer" className="bg-ink text-cream/80">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-5">
            <img src={BRAND.logo} alt="La Contadina" className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/40" />
          </div>
          <p className="font-serif text-2xl text-cream">Pizzeria e Trattoria</p>
          <p className="font-serif text-3xl text-gold leading-tight">„{BRAND.name}"</p>
          <p className="text-sm mt-4 text-cream/60 leading-relaxed">Authentische italienische Küche im Herzen von {BRAND.district}, {BRAND.since.toLowerCase()}.</p>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.25em] uppercase mb-5">Navigation</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><a href="https://shop.lacontadina-dresden.de/" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">Speisen bestellen</a></li>
            <li><Link to="/gutschein" className="hover:text-gold transition-colors">Gutschein</Link></li>
            <li><Link to="/ueber-uns" className="hover:text-gold transition-colors">Über uns</Link></li>
            <li><Link to="/olivenoel" className="hover:text-gold transition-colors">Olivenöl</Link></li>
            <li><Link to="/karriere" className="hover:text-gold transition-colors">Karriere</Link></li>
            <li><Link to="/catering" className="hover:text-gold transition-colors">Catering & Events</Link></li>
            <li><Link to="/kontakt" className="hover:text-gold transition-colors">Kontakt & Reservierung</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.25em] uppercase mb-5">Kontakt</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><MapPin size={18} className="text-gold shrink-0 mt-0.5" /><span>{b.address}</span></li>
            <li><a href={BRAND.phoneHref} className="flex gap-3 hover:text-gold transition-colors"><Phone size={18} className="text-gold shrink-0" />{b.phone}</a></li>
            <li className="flex gap-3"><Bus size={18} className="text-gold shrink-0 mt-0.5" /><span>{BRAND.transit.bus}</span></li>
            <li className="flex gap-3"><TramFront size={18} className="text-gold shrink-0 mt-0.5" /><span>{BRAND.transit.tram}</span></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gold text-xs tracking-[0.25em] uppercase mb-5">Öffnungszeiten · {season.label}</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            {season.hours.map((h) => {
              const isToday = h.day === today;
              return (
                <li key={h.day} className={`flex justify-between gap-3 ${isToday ? "text-orange-400 font-medium" : ""}`}>
                  <span className={isToday ? "text-orange-400" : "text-cream/90"}>{h.day}{isToday && " ·"}</span>
                  <span className={`text-xs text-right ${isToday ? "text-orange-400" : h.closed ? "text-wine/80" : ""}`}>{h.time}</span>
                </li>
              );
            })}
          </ul>
          <p className="text-xs text-gold/80 mt-4">{b.hoursNote}</p>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-cream/40">© {new Date().getFullYear()} {BRAND.name} · {BRAND.family}. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-5">
            <Link to="/impressum" className="text-xs text-cream/50 hover:text-gold transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="text-xs text-cream/50 hover:text-gold transition-colors">Datenschutz</Link>
            <a href={b.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="text-cream/50 hover:text-gold transition-colors"><Facebook size={18} /></a>
            <Link to="/admin" className="text-cream/30 hover:text-gold/70 transition-colors text-xs">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
